
import { useMemo } from "react";

export function useChartConfig() {
  const chartConfig = useMemo(() => ({
    current: { 
      label: 'Current State',
      theme: { light: '#8E9196', dark: '#8E9196' }
    },
    target: {
      label: 'Target State',
      theme: { light: '#e87a2e', dark: '#e87a2e' }
    }
  }), []);

  return chartConfig;
}
